export default __webpack_public_path__ + "static/media/soap.266a0946.png";